import { Pipe, PipeTransform } from '@angular/core';
import { CanalPropostaEnum } from '../shared/models/canal-proposta-enum.model';

@Pipe({
  name: 'canaisPropostas'
})
export class CanaisPropostasPipe implements PipeTransform {

  transform(canalProposta: CanalPropostaEnum): string {
    switch (canalProposta) {
      case CanalPropostaEnum.RENEGOCIACAO_CALL:
        return 'Call Center';

      case CanalPropostaEnum.RENEGOCIACAO_CYBER:
        return 'Assessoria';

      case CanalPropostaEnum.RENEGOCIACAO_DAP_PARCELADO:
        return 'Anistia';

      case CanalPropostaEnum.RENEGOCIACAO_MASSIVA:
        return 'Massiva';

      default:
        return '';
    }
  }

}

